module.exports = __webpack_public_path__ + "img/UY.32056a10.png";